
import { KpiCardType } from './types';

export const defaultCards: KpiCardType[] = [
  {
    id: 'consumption',
    title: 'Water Consumption',
    component: null,
    visible: true,
    order: 0,
  },
  {
    id: 'flowRate',
    title: 'Flow Rate',
    component: null,
    visible: true,
    order: 1,
  },
  {
    id: 'pressure',
    title: 'Water Pressure',
    component: null,
    visible: true,
    order: 2,
  },
  {
    id: 'issues',
    title: 'Active Issues',
    component: null,
    visible: true,
    order: 3,
  },
  {
    id: 'consumptionChart',
    title: 'Water Consumption Trends',
    component: null,
    visible: true,
    order: 4,
  },
  {
    id: 'waterQuality',
    title: 'Water Quality',
    component: null,
    visible: true,
    order: 5,
  },
  {
    id: 'distributionEfficiency',
    title: 'Distribution Efficiency',
    component: null,
    visible: true,
    order: 6,
  },
  {
    id: 'equipmentHealth',
    title: 'Equipment Health',
    component: null,
    visible: true,
    order: 7,
  },
];
